import initGsapScrollState from "../triggers/gsapScrollState";
import initGsapAos from "../triggers/gsapAos";
import initGsapUnveil from "../triggers/gsapUnveil";
import initGsapSticker from "../triggers/gsapSticker";
import initGsapOdometer from "../triggers/gsapOdometer";

export default function initGsapTriggers() {
    initGsapScrollState();
    initGsapAos();
    initGsapSticker();
    initGsapOdometer();

    if (MNK) {
        initGsapUnveil();
    }
}
